var map = {
	"./brsurgery/background.svg": "72df",
	"./iriom/background.svg": "fc32",
	"./master3ep/background.svg": "319a",
	"./mrm/background.svg": "e9b7",
	"./nellpay/background.svg": "b280",
	"./tradicash/background.svg": "0775",
	"./work8/background.svg": "b20d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90b0";